import React, { Component } from 'react'
import ApartmentBox from '@assets/js/elements/components/ApartmentBox'
import Preloader from '@assets/js/elements/components/Preloader'
import Collapsible from 'react-collapsible'

import SearchFilters from './SearchFilters'
import ApartmentsMap from '../components/ApartmentsMap'
import { DEFAULT_FILTERS } from '../filtersList'

import '@assets/sass/search-results/style.scss'
import { getTranslations } from '@assets/js/functions/helpers'
import ReactGA from '../../utils/react-ga'

const queryString = require('query-string')

export const DEFAULT_PER_PAGE = 18

export default class SearchResults extends Component {
    state = {
        apartments: [],
        apartmentsCount: 0,
        apartmentsMapPoints: null,
        searchPostId: null,
        mapExpanded: false,
        mapLoaded: false,
        filters: {
            location: null,
            date_from: null,
            date_to: null,
            guests_number: null,
            priceMin: null,
            priceMax: null,
            roomMin: null,
            roomMax: null,
            parkingAssigned: null,
            pets: null,
            wifi: null,
        },
        isLoadingResults: false,
        isFirstLoading: true,
        scrolled: false,
        currentPage: 1,
        totalPages: 1,
        totalApartments: 0,
        hasMorePages: false,
        lastScrollY: 0
    }

    componentWillMount() {
        const queryParams = queryString.parse(window.location.search, { arrayFormat: 'bracket' })
        const date_from = queryParams['check_in']
        const date_to = queryParams['check_out']
        const guests_number = queryParams['persons']
        let location = ''
        const searchPostId = this.getPostId()

        if (typeof queryParams.lokalizacja !== 'undefined') {
            location = queryParams.lokalizacja !== '' ? queryParams.lokalizacja.replace('&amp;', '&') : ''
        } else {
            location = this.getLocationFromURL()
        }

        if (typeof localization !== 'undefined' && localization !== null) {
            location = localization
        }

        location = location.replace('&amp;', '&')

        this.setState({
            searchPostId,
            filters: {
                ...this.state.filters,
                location,
                date_to,
                date_from,
                guests_number,
                search_result_id,
            },
        })
    }

    componentDidMount() {
        window.onbeforeunload = function () {
            window.scrollTo(0, 0)
        }

        window.addEventListener('scroll', this.handleScroll)
        this.fetchApartments()
        this.isLowWindowHeight()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    getLocationFromURL = () => {
        const url = window.location.pathname
        const pattern = /-.*-/g
        const isLocationInURL = url.match(pattern)

        if (!isLocationInURL) return ''

        // Remove first and last '-' sign from URL pathname
        const locationInURL = isLocationInURL[0].split('')

        locationInURL.pop()
        locationInURL.shift()
        return locationInURL.join('').replace('&amp;', '&')
    }

    fetchApartments = (appendResults = false) => {
        const { currentPage, searchPostId, filters, apartments } = this.state
        const query = { ...searchPostId, ...filters }

        let urlSearch = window.location.search
        if (urlSearch) {
            urlSearch = urlSearch.replace('?', '&')
        }
        urlSearch = urlSearch ? urlSearch : ''

        this.setState({
            isLoadingResults: true,
            isFirstLoading: !appendResults // Preloader tylko gdy nie doklejamy wyników
        })

        fetch(
            '/api/search-results-paged?' +
                'page=' + currentPage +
                '&' +
                queryString.stringify(query, { arrayFormat: 'bracket' }) +
                '&favourite=' +
                this.props.favourite +
                urlSearch,
        )
            .then((response) => {
                return response.json()
            })
            .then((body) => {
                const { data, meta } = body
                
                // Jeśli appendResults = true, doklejamy nowe apartamenty do istniejących
                const newApartments = appendResults ? [...apartments, ...data] : data
                
                this.setState({
                    apartments: newApartments,
                    apartmentsCount: newApartments.length,
                    totalApartments: meta.total,
                    totalPages: meta.last_page,
                    hasMorePages: meta.current_page < meta.last_page,
                    apartmentsFetched: true,
                    isLoadingResults: false,
                    isFirstLoading: false,
                    fetchError: false,
                })
            })
            .catch((error) => {
                this.setState({
                    fetchError: true,
                    isLoadingResults: false,
                    isFirstLoading: false,
                })
            })
    }

    onKeyPress = (event) => {
        if (event.code === 'Enter') {
            this.fetchApartments()
        }
    }

    onChangeFilter = (newFilter) => {
        const currentFilters = this.state.filters
        const updatedFilters = { ...currentFilters, ...newFilter }

        this.setState(
            {
                searchPostId: null,
                filters: updatedFilters,
                currentPage: 1,
                apartments: [], // Czyszczenie wyników
                isLoadingResults: true,
                isFirstLoading: true
            },
            () => {
                this.updateURL(updatedFilters)
                this.fetchApartments()
            },
        )
    }

    updateURL = (filters) => {
        const params = new URLSearchParams()
        
        // Dodaj lokalizację jako 'lokalizacja'
        if (filters.location) {
            params.set('lokalizacja', filters.location)
        }
        
        // Daty
        if (filters.date_from) {
            params.set('check_in', filters.date_from)
        }
        if (filters.date_to) {
            params.set('check_out', filters.date_to)
        }
        
        // Liczba gości
        if (filters.guests_number) {
            params.set('persons', filters.guests_number)
        }
        
        // Filtry zaawansowane
        if (filters.priceMin) {
            params.set('priceMin', filters.priceMin)
        }
        if (filters.priceMax) {
            params.set('priceMax', filters.priceMax)
        }
        if (filters.roomMin) {
            params.set('roomMin', filters.roomMin)
        }
        if (filters.roomMax) {
            params.set('roomMax', filters.roomMax)
        }
        if (filters.wifi) {
            params.set('wifi', filters.wifi)
        }
        if (filters.parkingAssigned) {
            params.set('parkingAssigned', filters.parkingAssigned)
        }
        if (filters.pets) {
            params.set('pets', filters.pets)
        }
        
        // Aktualizuj URL bez przeładowania strony
        const newURL = window.location.pathname + '?' + params.toString()
        window.history.pushState({ path: newURL }, '', newURL)
    }

    handleScroll = (e) => {
        this.scrollTop()
        this.renderNextResults(e)
    }

    handleMapTrigger = (shouldBeExpanded) => {
        if (shouldBeExpanded) {
            ReactGA.event({
                category: 'Wyszukiwarka apartamentów',
                action: 'Klik pokaż mapę',
            })
        }

        this.setState({
            mapExpanded: shouldBeExpanded,
        })
    }

    renderNextResults = (e) => {
        const { hasMorePages, isLoadingResults, currentPage, lastScrollY } = this.state
        const currentScrollY = window.scrollY
        
        // Sprawdź kierunek scrollu - tylko scroll w dół
        const isScrollingDown = currentScrollY > lastScrollY
        
        // Aktualizuj lastScrollY
        this.setState({ lastScrollY: currentScrollY })
        
        // Nie ładuj jeśli: loading, brak kolejnych stron, lub scroll w górę
        if (isLoadingResults || !hasMorePages || !isScrollingDown) {
            return
        }
        
        const searchResultsElement = document.getElementById('search-results')
        if (!searchResultsElement) {
            return
        }
        
        const nearBottom = searchResultsElement.getBoundingClientRect().bottom - 500 <= window.innerHeight

        if (nearBottom) {
            this.setState(
                {
                    currentPage: currentPage + 1,
                },
                () => {
                    this.fetchApartments(true) // true = doklejaj wyniki
                }
            )
        }
    }

    getPostId = () => {
        const url = window.location.pathname
        const patternDigitsFromEnd = /\d*$/g
        const foundPostId = url.match(patternDigitsFromEnd)

        if (foundPostId) {
            return foundPostId[0]
        }

        return ''
    }

    getApartmentUrl = (apartment) => {
        const {
            filters: { date_from, date_to, guests_number },
        } = this.state

        if (date_from && date_to) {
            const stayDate = {
                check_in: date_from,
                check_out: date_to,
                guests: guests_number,
            }

            return `/${apartment.slug}?${queryString.stringify(stayDate)}`
        }
        return `/${apartment.slug}`
    }

    renderApartmentBoxes = (translations) => {
        return this.state.fetchError ? (
            <div className="jumbotron">
                <div className="well">
                    <h3>{translations['no-apartments-data']}</h3>
                </div>
            </div>
        ) : (
            this.state.apartments.map((apartment) => {
                return (
                    <ApartmentBox
                        key={apartment.id}
                        apartment={apartment}
                        translations={translations}
                        apartmentUrl={this.getApartmentUrl(apartment)}
                        carousel={true}
                    />
                )
            })
        )
    }

    renderNoResults = (textContent, secondaryContent) => {
        if (this.state.apartmentsFetched) {
            return (
                <div className="well no-results">
                    <h2 className="no-results__heading">
                        {textContent}
                        <br />
                        {secondaryContent}
                        <br />
                        <a className="no-results__link" href="tel:+48585858058">
                            +48 58 58 58 058
                        </a>
                    </h2>
                </div>
            )
        }
    }

    handleSearchFiltersScroll = () => {
        const isLoadingResults = window.scrollY !== 0
    }

    scrollTop = () => {
        if (window.scrollY > 500 && !this.state.scrolled) {
            this.setState({ scrolled: true })
        } else if (window.scrollY === 0 && this.state.scrolled) {
            this.setState({ scrolled: false })
        }
    }

    isLowWindowHeight = () => {
        setTimeout(() => {
            const filtersHeight = document.querySelector('.search-filters').offsetHeight
            const isLowHeight = window.innerHeight - filtersHeight < 725

            this.setState({
                lowWindowHeight: isLowHeight,
            })
        }, 500)
    }

    handleMapOpening = () => {
        this.setState({
            mapLoaded: true,
        })
    }

    getFiltersCount = (filters) => {
        return Object.values(filters).filter(
            (filterValue, index) =>
                filterValue !== null &&
                filterValue !== undefined &&
                ![
                    'apartmentType',
                    'date_from',
                    'date_to',
                    'guests_number',
                    'location',
                    'meta[hotelowa-posciel-i-reczniki]',
                    'meta[hotelowa-posciel]',
                ].includes(Object.keys(filters)[index]),
        ).length
    }

    handleClearFilters = () => {
        this.setState(
            {
                filters: DEFAULT_FILTERS,
                currentPage: 1,
                apartments: [],
                isLoadingResults: true,
                isFirstLoading: true
            },
            () => {
                this.updateURL(DEFAULT_FILTERS)
                this.fetchApartments()
            }
        )
    }

    renderErrorView = (textContent, secondaryContent) => {
        return (
            <div className="well no-results">
                <h2 className="no-results__heading">
                    {textContent}
                    <br />
                    {secondaryContent}
                    <br />
                    <a className="no-results__link" href="tel:+48585858058">
                        +48 58 58 58 058
                    </a>
                </h2>
            </div>
        )
    }

    render() {
        const {
            apartments,
            apartmentsCount,
            totalApartments,
            isLoadingResults,
            lowWindowHeight,
            mapExpanded,
            mapLoaded,
            filters,
            scrolled,
        } = this.state
        const translations = getTranslations()

        return (
            <div className={lowWindowHeight ? 'low-window-height' : ''}>
                <SearchFilters
                    initialFilters={filters}
                    onChangeFilter={this.onChangeFilter}
                    onClickSearch={this.fetchApartments}
                    onKeyPress={this.onKeyPress}
                    translations={translations}
                    apartmentsCount={totalApartments}
                    filtersCount={this.getFiltersCount(filters)}
                    onMapTriggerClick={this.handleMapTrigger}
                    onAdvancedFiltersClick={this.isLowWindowHeight}
                    windowScrolled={scrolled}
                    onSearchFiltersScroll={this.handleSearchFiltersScroll}
                    mapExpanded={mapExpanded}
                    clearFilters={this.handleClearFilters}
                    filters={filters}
                >
                    <div className="search-results__map-wrapper">
                        <Collapsible id="search-results__map" open={mapExpanded} onOpening={this.handleMapOpening}>
                            {mapLoaded && <ApartmentsMap points={apartments} />}
                        </Collapsible>
                    </div>
                </SearchFilters>
                {filters.location && <h1 className="search-results__header">{translations['apartments']} - {filters.location}</h1>}
                <div className="search-results__wrapper">
                    {/* Preloader tylko przy pierwszym ładowaniu */}
                    {this.state.isFirstLoading && <Preloader visible={true} />}

                    {/* Wyniki - pokazuj tylko jeśli nie jest pierwsze ładowanie lub mamy już apartamenty */}
                    {(!this.state.isFirstLoading || apartments.length > 0) && (
                        <div className="search-results" id="search-results">
                            {this.state.fetchError
                                ? this.renderErrorView(
                                      translations['error-yieldplanet-header'],
                                      translations['error-yieldplanet-description'],
                                  )
                                : [
                                      apartments.length
                                          ? this.renderApartmentBoxes(translations)
                                          : this.renderNoResults(
                                                translations['no-results'],
                                                translations['call-our-office'],
                                            ),
                                  ]}
                        </div>
                    )}
                    
                    {/* Loading text pod wynikami - tylko przy doczytywaniu kolejnych stron */}
                    {this.state.isLoadingResults && this.state.currentPage > 1 && !this.state.isFirstLoading && (
                        <div className="search-results__loading">
                            <p className="search-results__loading-text">
                                {translations['loading'] || 'loading...'}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
